'use client';

import { MapPinOff } from 'lucide-react';

import { ErrorShell, type ErrorShellAction } from './error-shell';

/**
 * NotFoundScreen - the branded 404 (app/not-found.tsx). Dead marketing URLs
 * used to fall through to the unbranded Next.js default; this keeps the
 * funnel with the brand wink and two recovery paths (home composer + docs).
 */
export const NotFoundScreen = () => {
	const actions: ErrorShellAction[] = [
		// `href`, not an imperative `window.location.href`: both targets belong to
		// `apps/marketing`, and this screen also renders in `apps/web`. The
		// href goes through the host's link bridge, which prefixes the marketing
		// origin when the two apps are on different ports (local dev).
		{ label: 'Drop your pile', href: '/', variant: 'primary' },
		{ label: 'Browse the docs', href: '/docs', variant: 'secondary' },
	];

	return (
		<ErrorShell
			icon={<MapPinOff className="size-10 text-neutral/40" strokeWidth={1.5} />}
			title="This page isn't in the map."
			description="Whatever you were looking for, it was probably filed somewhere it shouldn't have been. We know the feeling - it's the whole reason Naumu exists."
			actions={actions}
		/>
	);
};
